/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import Table from "./components/table";
import Table2 from "./components/table2";
import Table3 from "./components/table3";
import Table4 from "./components/table4";
import Table5 from "./components/table5";
import Table6 from "./components/table6";
import Table7 from "./components/table7";
import Table8 from "./components/table8";
import Table9 from "./components/table9";
import Table10 from "./components/table10";
import Table11 from "./components/table11";

import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import form from "./schema/form";
import initialValues9 from "./schema/initialValues9";
import validation9 from "./schema/validations9";
import form9 from "./schema/form9";
import initialValues8 from "./schema/initialValues8";
import validation8 from "./schema/validations8";
import form8 from "./schema/form8";
import initialValues6 from "./schema/initialValues6";
import validation6 from "./schema/validations6";
import form6 from "./schema/form6";
import initialValues7 from "./schema/initialValues7";
import validation7 from "./schema/validations7";
import form7 from "./schema/form7";
import formNull from "./schema/formNull";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import Tabs from "./components/tabs";
import Actions from "./components/actions";
import ModalCommon from "components/Modal";
import ModalContent from "./components/modalContent";
import validationNull from "./schema/validationsNull";
import initialValuesNull from "./schema/initialValuesNull";
import Fields6 from "./components/field6";
import Fields7 from "./components/field7";
import Fields8 from "./components/field8";
import Fields9 from "./components/field9";

import Fields12 from "./components/field12";
import initialValues12 from "./schema/initialValues12";
import validation12 from "./schema/validations12";
import form12 from "./schema/form12";
import Table12 from "./components/table12";

import Fields13 from "./components/field13";
import initialValues13 from "./schema/initialValues13";
import validation13 from "./schema/validations13";
import form13 from "./schema/form13";
import Table13 from "./components/table13";

import Table14 from "./components/table14";

import Table15 from "./components/table15";

import Fields038C from "./components/field038C";
import initialValues038C from "./schema/initialValues038C";
import validation038C from "./schema/validations038C";
import form038C from "./schema/form038C";
import Table038C from "./components/table038C";

import Table039 from "./components/table039";

import CorporateIncomeTaxTable19 from "./components/table19";
import CorporateIncomeTaxTable20A from "./components/table20a";
import CorporateIncomeTaxTable20B from "./components/table20b";
import CorporateIncomeTaxTable21 from "./components/table21";
import rangePlugin from "flatpickr/dist/plugins/rangePlugin";
import CorporateIncomeTaxTable18 from "./components/table18";

import TableGDLK01a from "./components/tableGDLK01a";
import TableGDLK01b from "./components/tableGDLK01b";
import TableGDLK01c from "./components/tableGDLK01c";
import TableGDLK01d from "./components/tableGDLK01d";
import TableGDLK01e from "./components/tableGDLK01e";
import TableGDLK01f from "./components/tableGDLK01f";

export default function CorporateIncomeTax03() {
  const { formId, formField } = form;
  const { formIdNull, formFieldNull } = formNull;
  const { formId6, formField6 } = form6;
  const { formId7, formField7 } = form7;
  const { formId8, formField8 } = form8;
  const { formId9, formField9 } = form9;
  const { formId12, formField12 } = form12;
  const { formId13, formField13 } = form13;
  const { formId038C, formField038C } = form038C;

  const [open, setOpen] = React.useState(true);
  const [tab, setTab] = React.useState(0);
  const [pickAll, setPickAll] = React.useState(false);

  const [list, setList] = React.useState([
    { name: "03-1A/TNDN", checked: false },
    { name: "03-1B/TNDN", checked: false },
    { name: "03-1C/TNDN", checked: false },
    { name: "03-2/TNDN", checked: false },
    { name: "03-3A/TNDN", checked: false },
    { name: "03-3B/TNDN", checked: false },
    { name: "03-3C/TNDN", checked: false },
    { name: "03-3D/TNDN", checked: false },
    { name: "03-4/TNDN", checked: false },
    { name: "03-5/TNDN", checked: false },
    { name: "03-6/TNDN", checked: false },
    { name: "03-8/TNDN", checked: false },
    { name: "03-8A/TNDN", checked: false },
    { name: "03-8B/TNDN", checked: false },
    { name: "03-8C/TNDN", checked: false },
    { name: "03-9/TNDN", checked: false },
    { name: "GDLK NĐ132 01", checked: false },
    { name: "GDLK NĐ132 02", checked: false },
    { name: "GDLK NĐ132 03", checked: false },
    { name: "GDLK NĐ132 04", checked: false },
    { name: "PL 92/2021/NĐ-CP", checked: false },
  ]);

  const handleSubmit = async (values, action) => {
    console.log({ values });
  };

  const handleChangeSwitch = (name, checked) => {
    if (pickAll) return;
    setList((prev) =>
      prev.map((item) => {
        if (item.name === name) {
          return { ...item, checked };
        }
        return item;
      })
    );
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!open && (
        <>
          <Tabs tab={tab} setTab={setTab} list={list} pickAll={pickAll} />
          <Actions
            list={list}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        </>
      )}
      <ModalCommon
        open={open}
        setOpen={setOpen}
        content={
          <ModalContent
            list={list}
            setList={setList}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        }
      >
        {tab === 0 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Tờ khai quyết toán thuế thu nhập doanh nghiệp (Mẫu số 03/TNDN)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Fields
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                  />
                  <Table
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 1 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục 03-1A
              </Typography>
              <Typography variant="h4" textTransform="uppercase">
                Kết quả hoạt động sản xuất kinh doanh
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                Áp dung đối với ngành sản xuất, thương mại, dịch vụ (trừ công ty an ninh, quốc
                phòng)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValuesNull}
              validationSchema={validationNull}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formIdNull} autoComplete="off">
                  <Table2 setFieldValue={setFieldValue} />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 2 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục 03-1B
              </Typography>
              <Typography variant="h4" textTransform="uppercase">
                Kết quả hoạt động sản xuất kinh doanh
              </Typography>

              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                Áp dung đối với ngành ngân hàng tín dụng
              </Typography>
            </Box>
            <Formik
              initialValues={initialValuesNull}
              validationSchema={validationNull}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formIdNull} autoComplete="off">
                  <Table3 setFieldValue={setFieldValue} />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 3 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục 03-1C
              </Typography>
              <Typography variant="h4" textTransform="uppercase">
                Kết quả hoạt động sản xuất kinh doanh
              </Typography>

              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                Áp dung đối với Công ty chứng khoán, Công ty quản lý quỹ đầu tư chứng khoán
              </Typography>
            </Box>
            <Formik
              initialValues={initialValuesNull}
              validationSchema={validationNull}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formIdNull} autoComplete="off">
                  <Table4 setFieldValue={setFieldValue} />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 4 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục 03-2/TNDN
              </Typography>
              <Typography variant="h4" textTransform="uppercase">
                Chuyển lỗ
              </Typography>
            </Box>
            <Formik
              initialValues={initialValuesNull}
              validationSchema={validationNull}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formIdNull} autoComplete="off">
                  <Table5 setFieldValue={setFieldValue} />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 5 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục 03-3A/TNDN
              </Typography>
              <Typography variant="h4" textTransform="uppercase">
                Thuế thu nhập doanh nghiệp được nhận ưu đãi
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                Đối với thu nhập từ dự án đầu tư mới, thu nhập của doanh nghiệp được hưởng ưu đãi
                thuế thu nhập doanh nghiệp
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues6}
              validationSchema={validation6}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId6} autoComplete="off">
                  <Fields6
                    formData={{
                      values,
                      touched,
                      formField6,
                      errors,
                    }}
                  />
                  <Table6 setFieldValue={setFieldValue} />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 6 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục 03-3B/TNDN
              </Typography>
              <Typography variant="h4" textTransform="uppercase">
                Thuế thu nhập doanh nghiệp được nhận ưu đãi
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                Đối với cơ sở kinh doanh đầu tư mở rộng quy mô, nâng cao công suất, đổi mới công
                nghệ sản xuất (dự án đầu tư mở rộng)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues7}
              validationSchema={validation7}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId7} autoComplete="off">
                  <Fields7
                    formData={{
                      values,
                      touched,
                      formField7,
                      errors,
                    }}
                  />
                  <Table7 setFieldValue={setFieldValue} />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 7 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục 03-3C/TNDN
              </Typography>
              <Typography variant="h4" textTransform="uppercase">
                Thuế thu nhập doanh nghiệp được nhận ưu đãi
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Áp dụng đối với doanh nghiệp sử dụng lao động là người dân tộc thiểu số hoặc doanh
                nghiệp hoạt động sản xuất, xây dựng, vận tải sử dụng nhiều lao động nữ)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues8}
              validationSchema={validation8}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId8} autoComplete="off">
                  <Fields8
                    formData={{
                      values,
                      touched,
                      formField8,
                      errors,
                    }}
                  />
                  <Table8 setFieldValue={setFieldValue} />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 8 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục 03-3D/TNDN
              </Typography>
              <Typography variant="h4" textTransform="uppercase">
                Thuế thu nhập doanh nghiệp được nhận ưu đãi
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Áp dụng đối với doanh nghiệp khoa học công nghệ hoặc doanh nghiệp thực hiện chuyển
                giao công nghệ thuộc lĩnh vực ưu tiên chuyển giao)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues9}
              validationSchema={validation9}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId9} autoComplete="off">
                  <Fields9
                    formData={{
                      values,
                      touched,
                      formField9,
                      errors,
                    }}
                  />
                  <Table9
                    formData={{
                      values,
                      touched,
                      formField9,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 9 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục 03-4/TNDN
              </Typography>
              <Typography variant="h4" textTransform="uppercase">
                Thuế thu nhập doanh nghiệp đã nộp ở nước ngoài
              </Typography>
            </Box>
            <Formik
              initialValues={initialValuesNull}
              validationSchema={validationNull}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formIdNull} autoComplete="off">
                  <Table10
                    formData={{
                      values,
                      touched,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 10 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục 03-5/TNDN
              </Typography>
              <Typography variant="h4" textTransform="uppercase">
                Thuế thu nhập đối với hoạt động chuyển nhượng bất động sản
              </Typography>
            </Box>
            <Formik
              initialValues={initialValuesNull}
              validationSchema={validationNull}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formIdNull} autoComplete="off">
                  <Table11
                    formData={{
                      values,
                      touched,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 11 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục 03-6/TNDN
              </Typography>
              <Typography variant="h4" textTransform="uppercase">
                Báo cáo trích lập, sử dụng quỹ khoa học và công nghệ
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues12}
              validationSchema={validation12}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId12} autoComplete="off">
                  <Fields12
                    formData={{
                      values,
                      touched,
                      formField12,
                      errors,
                    }}
                  />
                  <Table12
                    formData={{
                      values,
                      touched,
                      formField12,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 12 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục 03-8/TNDN
              </Typography>
              <Typography variant="h4" textTransform="uppercase">
                Bảng phân bổ số thuế thu nhập doanh nghiệp phải nộp đối với cơ sở sản xuất
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues13}
              validationSchema={validation13}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId13} autoComplete="off">
                  <Fields13
                    formData={{
                      values,
                      touched,
                      formField13,
                      errors,
                    }}
                  />
                  <Table13
                    formData={{
                      values,
                      touched,
                      formField13,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 13 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục 03-8A/TNDN
              </Typography>
              <Typography variant="h4" textTransform="uppercase">
                Bảng phân bổ số thuế thu nhập doanh nghiệp phải nộp đối với hoạt động chuyển nhượng
                bất động sản
              </Typography>
            </Box>
            <Formik
              initialValues={initialValuesNull}
              validationSchema={validationNull}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formIdNull} autoComplete="off">
                  <Table14
                    formData={{
                      values,
                      touched,
                      formField13,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 14 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục 03-8B/TNDN
              </Typography>
              <Typography variant="h4" textTransform="uppercase">
                Bảng phân bổ số thuế thu nhập doanh nghiệp (TNDN) phải nộp đối với hoạt động sản
                xuất thủy điện
              </Typography>
            </Box>
            <Formik
              initialValues={initialValuesNull}
              validationSchema={validationNull}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formIdNull} autoComplete="off">
                  <Table15
                    formData={{
                      values,
                      touched,
                      formField13,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 15 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục 03-8C/TNDN
              </Typography>
              <Typography variant="h4" textTransform="uppercase">
                Bảng phân bổ số thuế thu nhập doanh nghiệp phải nộp đối với hoạt động kinh doanh xổ
                số điện toán
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues038C}
              validationSchema={validation038C}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId038C} autoComplete="off">
                  <Fields038C
                    formData={{
                      values,
                      touched,
                      formField038C,
                      errors,
                    }}
                  />
                  <Table038C
                    formData={{
                      values,
                      touched,
                      formField038C,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 16 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục 03-9/TNDN
              </Typography>
              <Typography variant="h4" textTransform="uppercase">
                Bảng kê chứng từ nộp tiền thuế thu nhập doanh nghiệp tạm nộp của hoạt động
              </Typography>
            </Box>
            <Formik formIdNull onSubmit={handleSubmit}>
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formIdNull} autoComplete="off">
                  <Table039
                    formData={{
                      values,
                      touched,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 17 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục
              </Typography>
              <Typography variant="h4" textTransform="uppercase">
                Thông tin về quan hệ liên kết và giao dịch liên kết (Mẫu số 01)
              </Typography>
              <Typography variant="subtitle">
                (Kèm theo Tờ khai quyết toán thuế thu nhập doanh nghiệp số 03/TNDN)
              </Typography>
              <Typography variant="h5" fontWeight={400}>
                Kỳ tính thuế 2023 Từ ngày 01/01/2023 Đến ngày 31/12/2023
              </Typography>
            </Box>
            <Formik
              initialValues={initialValuesNull}
              validationSchema={validationNull}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formIdNull} autoComplete="off">
                  <TableGDLK01a
                    formData={{
                      values,
                      touched,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <TableGDLK01b
                    formData={{
                      values,
                      touched,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <TableGDLK01c
                    formData={{
                      values,
                      touched,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <TableGDLK01d
                    formData={{
                      values,
                      touched,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <TableGDLK01e
                    formData={{
                      values,
                      touched,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <TableGDLK01f
                    formData={{
                      values,
                      touched,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 18 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục danh mục các thông tin, tài liệu cần cung cấp tại hồ sơ quốc gia (Mẫu số 02)
              </Typography>
              <Typography variant="h4" textTransform="uppercase">
                (Kèm theo Tờ khai quyết toán thuế thu nhập doanh nghiệp số 03/TNDN)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues13}
              validationSchema={validation13}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId13} autoComplete="off">
                  <Grid container>
                    <Grid item xs={12} style={{ paddingTop: 0 }}>
                      <DatepickerField
                        options={{
                          plugins: [
                            new rangePlugin({
                              shorthand: true,
                              theme: "light",
                              dateFormat: "d-m-Y",
                            }),
                          ],
                          enableTime: false,
                        }}
                        name="taxCalculationPeriod"
                        label="Kỳ tính thuế"
                      />
                    </Grid>
                  </Grid>
                  <CorporateIncomeTaxTable18 setFieldValue={setFieldValue} />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 19 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục danh mục các thông tin, tài liệu cần cung cấp tại hồ sơ toàn cầu (Mẫu số 03)
              </Typography>
              <Typography variant="h4" textTransform="uppercase">
                (Kèm theo Tờ khai quyết toán thuế thu nhập doanh nghiệp số 03/TNDN)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues13}
              validationSchema={validation13}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId13} autoComplete="off">
                  <Grid container>
                    <Grid item xs={12} style={{ paddingTop: 0 }}>
                      <DatepickerField
                        options={{
                          plugins: [
                            new rangePlugin({
                              shorthand: true,
                              theme: "light",
                              dateFormat: "d-m-Y",
                            }),
                          ],
                          enableTime: false,
                        }}
                        name="taxCalculationPeriod"
                        label="Kỳ tính thuế"
                      />
                    </Grid>
                  </Grid>
                  <CorporateIncomeTaxTable19 setFieldValue={setFieldValue} />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 20 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục Kê khai thông tin báo cáo lợi nhuận liên quốc gia (Mẫu số 04)
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic">
                (Kèm theo Tờ khai quyết toán thuế thu nhập doanh nghiệp số 03/TNDN)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues13}
              validationSchema={validation13}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId13} autoComplete="off">
                  <Grid container>
                    <Grid item xs={12} style={{ paddingTop: 0 }}>
                      <DatepickerField
                        options={{
                          plugins: [
                            new rangePlugin({
                              shorthand: true,
                              theme: "light",
                              dateFormat: "d-m-Y",
                            }),
                          ],
                          enableTime: false,
                        }}
                        name="taxCalculationPeriod"
                        label="Kỳ tính thuế"
                      />
                    </Grid>
                  </Grid>
                  <CorporateIncomeTaxTable20A setFieldValue={setFieldValue} />
                  <CorporateIncomeTaxTable20B setFieldValue={setFieldValue} />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 21 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục Thuế thu nhập doanh nghiệp được giảm theo nghị quyết số 406/NQ-UBTVQH15
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues13}
              validationSchema={validation13}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId13} autoComplete="off">
                  <Grid container>
                    <Grid item xs={12} style={{ paddingTop: 0 }}>
                      <DatepickerField
                        options={{
                          plugins: [
                            new rangePlugin({
                              shorthand: true,
                              theme: "light",
                              dateFormat: "d-m-Y",
                            }),
                          ],
                          enableTime: false,
                        }}
                        name="taxCalculationPeriod"
                        label="Kỳ tính thuế"
                      />
                    </Grid>
                  </Grid>
                  <CorporateIncomeTaxTable21 setFieldValue={setFieldValue} />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
      </ModalCommon>
    </DashboardLayout>
  );
}

function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const {
    firstTime,
    supplementaryForThe,
    taxCalculationPeriod,
    taxId,
    taxpayerName,
    taxAgentName,
    taxAgentId,
    taxCalculationPeriodEnd,
    hightIncomeBusiness,
    percent,
    contract,
    contractDate,
  } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={taxCalculationPeriod.name}
            label={taxCalculationPeriod.label}
            error={errors.taxCalculationPeriod && touched.taxCalculationPeriod}
            success={
              values.taxCalculationPeriod?.toString().length > 0 && !errors.taxCalculationPeriod
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={taxCalculationPeriodEnd.name}
            label={taxCalculationPeriodEnd.label}
            error={errors.taxCalculationPeriodEnd && touched.taxCalculationPeriodEnd}
            success={
              values.taxCalculationPeriodEnd?.toString().length > 0 &&
              !errors.taxCalculationPeriodEnd
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name={firstTime.name} label={firstTime.label} value={values.firstTime} />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={supplementaryForThe.name}
            label={supplementaryForThe.label}
            value={values.supplementaryForThe}
            error={errors.supplementaryForThe && touched.supplementaryForThe}
            success={
              values.supplementaryForThe?.toString().length > 0 && !errors.supplementaryForThe
            }
          />
        </Grid>
        {/* //////////////////////// */}
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={hightIncomeBusiness.name}
            label={hightIncomeBusiness.label}
            value={values.hightIncomeBusiness}
            error={errors.hightIncomeBusiness && touched.hightIncomeBusiness}
            success={
              values.hightIncomeBusiness?.toString().length > 0 && !errors.hightIncomeBusiness
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={percent.name}
            label={percent.label}
            value={values.percent}
            error={errors.percent && touched.percent}
            success={values.percent?.toString().length > 0 && !errors.percent}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxpayerName.name}
            label={taxpayerName.label}
            value={values.taxpayerName}
            error={errors.taxpayerName && touched.taxpayerName}
            success={values.taxpayerName?.toString().length > 0 && !errors.taxpayerName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId.name}
            label={taxId.label}
            value={values.taxId}
            error={errors.taxId && touched.taxId}
            success={values.taxId?.toString().length > 0 && !errors.taxId}
          />
        </Grid>
        {/* //////////////////////// */}
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgentName.name}
            label={taxAgentName.label}
            value={values.taxAgentName}
            error={errors.taxAgentName && touched.taxAgentName}
            success={values.taxAgentName?.toString().length > 0 && !errors.taxAgentName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgentId.name}
            label={taxAgentId.label}
            value={values.taxAgentId}
            error={errors.taxAgentId && touched.taxAgentId}
            success={values.taxAgentId?.toString().length > 0 && !errors.taxAgentId}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={contract.name}
            label={contract.label}
            value={values.contract}
            error={errors.contract && touched.contract}
            success={values.contract?.toString().length > 0 && !errors.contract}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={contractDate.name}
            label={contractDate.label}
            error={errors.contractDate && touched.contractDate}
            success={values.contractDate?.toString().length > 0 && !errors.contractDate}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
